import Actions from "../Actions";
import logger from "../utils/LoggerFrontend";

export const saveUserFlatLogService = ({
  userProfile,
  orgaId = "default",
  orgaName = "default ",
  actionType,
  message
}) => {
  logger.log("saveUserFlatLogService", "user log data passed", {
    userProfile,
    orgaId,
    orgaName,
    actionType,
    message
  });
  const { userId, userName, orgas = {}, permissions = {} } = userProfile;
  const { roleId = "default" } = orgas[orgaId] || {};
  const { role: roleName = "default" } = permissions;
  const userFlatLogData = {
    meta: { type: actionType },
    roleId,
    roleName,
    type: actionType,
    userId,
    userName,
    orgaName,
    orgaId,
    originatorUserId: userId,
    originatorUserName: userName,
    message
  };

  logger.log("saveUserFlatLogService", "user log data to be save", {
    userFlatLogData
  });
  Actions.createUserLogsFlat(userFlatLogData);
};
